import { render, staticRenderFns } from "./subMulationExamPerson.vue?vue&type=template&id=4be5df51&scoped=true&"
import script from "./subMulationExamPerson.vue?vue&type=script&lang=js&"
export * from "./subMulationExamPerson.vue?vue&type=script&lang=js&"
import style0 from "./subMulationExamPerson.vue?vue&type=style&index=0&id=4be5df51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be5df51",
  null
  
)

export default component.exports